import { render, staticRenderFns } from "./AllowedHashAdd.vue?vue&type=template&id=686babb3&scoped=true&"
import script from "./AllowedHashAdd.vue?vue&type=script&lang=js&"
export * from "./AllowedHashAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686babb3",
  null
  
)

export default component.exports